import token from "./token"


function configRouter(router, logoutCallback) {
    router.beforeEach((to, from, next) => {
        const { tokenDisable = false } = to.meta
        if (tokenDisable) {
            if (token.hasToken())
                //如果有token不允许进入登录页
                next(false)
            else {
                //如果没有token，禁用token使用
                console.log("token disable")
                token.disable();
                next()
            }
        } else {
            if (token.hasToken()) {
                //允许使用token
                token.enable();
                next()
            } else {
                if (logoutCallback) logoutCallback.call(this)
            }
        }

    });
}





export default {
    config(router, logoutCallback) {
        configRouter(router, logoutCallback)
    }
}
